import {
  getAllTechnicianOrdersForCondtTabs,
  matchesCondtPendente,
  matchesCondtLiberado
} from './futuraRetornoCondt';

/**
 * Agrega Pendente/Liberado em todas as colunas visíveis. Liberado tem prioridade visual sobre Pendente.
 * @param {Record<string, object>|null|undefined} technicianGroups
 * @param {string[]} technicianNames — ex.: boardVisibleTechnicians
 * @returns {{ active: boolean, mode: 'pendente' | 'liberado' | null }}
 */
export function computeFuturaRetornoBoardBellState(technicianGroups, technicianNames, matcher = () => true) {
  if (!technicianGroups || !Array.isArray(technicianNames) || technicianNames.length === 0) {
    return { active: false, mode: null };
  }
  let anyPendente = false;
  let anyLiberado = false;
  for (const name of technicianNames) {
    const orders = getAllTechnicianOrdersForCondtTabs(technicianGroups, name);
    for (const o of orders) {
      if (!matcher(o)) continue;
      if (matchesCondtLiberado(o)) anyLiberado = true;
      if (matchesCondtPendente(o)) anyPendente = true;
    }
    if (anyLiberado && anyPendente) break;
  }
  if (anyLiberado) return { active: true, mode: 'liberado' };
  if (anyPendente) return { active: true, mode: 'pendente' };
  return { active: false, mode: null };
}

/**
 * Retorna resumo por técnico para painel de pendências do sino.
 * @param {Record<string, object>|null|undefined} technicianGroups
 * @param {string[]} technicianNames
 * @returns {{ rows: Array<{ technician: string, pendente: number, liberado: number }>, totals: { pendente: number, liberado: number } }}
 */
export function computeFuturaRetornoBoardBellTechnicianSummary(technicianGroups, technicianNames, matcher = () => true) {
  if (!technicianGroups || !Array.isArray(technicianNames) || technicianNames.length === 0) {
    return { rows: [], totals: { pendente: 0, liberado: 0 } };
  }

  const rows = [];
  let totalPendente = 0;
  let totalLiberado = 0;

  for (const technician of technicianNames) {
    const orders = getAllTechnicianOrdersForCondtTabs(technicianGroups, technician);
    let pendente = 0;
    let liberado = 0;

    for (const o of orders) {
      if (!matcher(o)) continue;
      if (matchesCondtPendente(o)) pendente += 1;
      if (matchesCondtLiberado(o)) liberado += 1;
    }

    if (pendente > 0 || liberado > 0) {
      rows.push({ technician, pendente, liberado });
      totalPendente += pendente;
      totalLiberado += liberado;
    }
  }

  rows.sort((a, b) => {
    if (b.liberado !== a.liberado) return b.liberado - a.liberado;
    if (b.pendente !== a.pendente) return b.pendente - a.pendente;
    return a.technician.localeCompare(b.technician, 'pt-BR');
  });

  return {
    rows,
    totals: {
      pendente: totalPendente,
      liberado: totalLiberado
    }
  };
}
